import React, { useEffect, useRef, useState } from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { showToast } from "../../Components/Toast";
import { useDispatch, useSelector, connect } from "react-redux";
import { setBillInfo } from "../../Redux/Actions";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { ReactComponent as Delete } from "../../assets/icons/delete.svg";
import FloatingInput from "../../Components/Common/FloatingForm";
import Button from "../../Components/Common/Button";

const PayWithBillId = ({ setBillToPay, isLogin }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const [error, setError] = useState(false);
  const [state, setState] = useState("");
  const [disable, setDisable] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [regex, setRegex] = useState({});
  const textInputRef = useRef(null);
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  const [billId, setbillId] = useState("");
  const [paymentId, setpaymentId] = useState("");
  const history = useHistory();
  function onSubmit() {
    setDisable(true);
    const integerBillId = parseInt(billId);
    const integerPayId = parseInt(paymentId);
    const url = `V1/Bill/Inquiry/BillPay?bill_id=${integerBillId}&pay_id=${integerPayId}`;
    if (integerBillId && integerPayId) {
      ApiCall(
        "get",
        url,
        {},
        "Bill",
        token,
        (result) => {
          setDisable(false);
          if (result.data != null) {
            const isPaid = result.data.payment_status == 1 ? true : false;
            if (isPaid) {
              showToast(
                "قبض مورد نظر به وسیله کنتور پرداخت شده است. برای مشاهده به سوابق پرداخت مراجعه نمایید.",
                "#f6b517"
              );
            } else {
              setBillToPay({ ...result.data, paymentType: "SMS" });
              history.push("billInfo");
            }
          }
        },
        (err) => setDisable(false)
      );
    } else {
      showToast("لطفا شناسه قبض و شناسه پرداخت را وارد نمایید", "#f6b517");
    }
  }

  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text={"پرداخت با شناسه قبض و پرداخت"} />
        <div className="divider" />
        <div className="divider" />
        <img
          src={require("../../assets/images/PayWithBillId.png")}
          alt=""
          id="companyImage"
          style={{ height: 100 }}
        />
        <div className="divider" />
        <div className="divider" />
        <div className="divider" />
        <div className="divider" />
        <FloatingInput
          value={billId}
          type={"tel"}
          setValue={setbillId}
          labelShort={"شناسه قبض"}
          label={"شناسه قبض"}
        />
        <div className="divider" />
        <FloatingInput
          value={paymentId}
          type={"tel"}
          setValue={setpaymentId}
          labelShort={"شناسه پرداخت"}
          label={"شناسه پرداخت"}
        />
        <Button
          title={"تایید اطلاعات و پرداخت قبض"}
          bottom={5}
          loading={disable}
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    billInfo: state.auth.billInfo,
    token: state.auth.token,
    isLogin: state.auth.isLogin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBillToPay: (info) => dispatch(setBillInfo(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PayWithBillId);
